/**
 * @file 金额输入区
 */
import React from 'react';
import cls from 'classnames';
import { useBalance, useInputStatus } from './hooks';
import BigNumber from 'bignumber.js';
import { useFm } from '@web3/base-hooks';
import { Tooltip } from '@bfe/moly';
import { Web3AssetsIcon } from '@bfe/moly-icons';
import { useAccountInfoContext } from '@/hooks/useAccountInfo';
import { GasStore } from '@/types/unstake';
import { formatUSDYield } from '@/utils/num';
import { formatNumber } from '@web3/base-utils';

import styles from './index.module.scss';

interface Props {
  unstakeAmount: string;
  gasStore: GasStore;
  onChangeTextIsError: (v: boolean) => void;
  onChangeAmount: (v: string) => void;
}

export const InputArea = (props: Props) => {
  const { unstakeAmount, gasStore, onChangeAmount, onChangeTextIsError } =
    props;
  const fm = useFm();
  const { accountInfo } = useAccountInfoContext();
  const { balance } = useBalance();

  const { inputFontSize, inputErrorText, isShowMax, onMax } = useInputStatus(
    balance,
    unstakeAmount,
    onChangeAmount,
    onChangeTextIsError,
    gasStore
  );

  const { lpCoinDetail } = accountInfo || {};

  return (
    <div
      className={cls(styles.container, {
        [styles.error]: !!inputErrorText,
      })}
    >
      <div className={styles.currentTokenInfo}>
        <div className={styles.currentToken}>
          {fm('redeem')}
          <img
            src={lpCoinDetail?.iconNightUrl}
            className={styles.currentTokenIcon}
          />
          <Tooltip title={lpCoinDetail?.symbol ?? ''}>
            <div className={styles.symbol}>{lpCoinDetail?.symbol ?? ''}</div>
          </Tooltip>
        </div>
        <div className={styles.currentTokenRight}>
          <Web3AssetsIcon className={styles.walletIcon} />
          {accountInfo.lpTokens ? (
            <Tooltip title={accountInfo.lpTokens}>
              <div className={styles.balance}>{`${formatNumber(
                accountInfo?.lpTokens,
                {
                  kmb: false,
                  decimal: 8,
                  smallNumberUseValidDigits: false,
                  collapseZero: false,
                  roundMode: BigNumber.ROUND_DOWN,
                }
              )} ${lpCoinDetail?.symbol ?? ''}`}</div>
            </Tooltip>
          ) : (
            <div
              className={styles.balance}
            >{`-- ${lpCoinDetail?.symbol ?? ''}`}</div>
          )}
        </div>
      </div>
      <div className={styles.inputArea}>
        {isShowMax && (
          <div className={styles.max} onClick={onMax}>
            {fm('max')}
          </div>
        )}
        <input
          type="text"
          className={styles.input}
          style={{
            fontSize: inputFontSize,
          }}
          value={unstakeAmount}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            onChangeAmount(event.target.value);
          }}
          placeholder="0.00"
        />
      </div>

      <div className={styles.stakeAmountValue}>
        {lpCoinDetail?.price && unstakeAmount
          ? formatUSDYield(
              BigNumber(unstakeAmount).times(lpCoinDetail?.price).toString()
            )
          : formatUSDYield('0')}
      </div>

      {!!inputErrorText && (
        <div className={styles.inputError}>{inputErrorText}</div>
      )}
    </div>
  );
};
